<template>
  <div class="cb_sim_child__container">
    <div class="cb_sim_child_header">
      <div class="cb_sim_action_buttons">
        <div
          class="btn btn_noborder"
          style="border: 0"
          @click="deleteChild"
          :title="t('remove child from simulation')"
        >
          <font-awesome-icon icon="times" />
        </div>
      </div>
      <div class="cb_sim_collapsible_btn" @click="toggleCollapsible">
        <span v-if="collapsed">
          <font-awesome-icon icon="chevron-right" />
        </span>
        <span v-if="!collapsed">
          <font-awesome-icon icon="chevron-down" />
        </span>
        {{ naam }}
        <span class="cb_sim_showhide" v-if="collapsed">
          {{ t("show_details") }}
        </span>
        <span class="cb_sim_showhide" v-if="!collapsed">
          {{ t("hide_details") }}
        </span>
      </div>
    </div>

    <!-- END COL -->
    <div :class="{ cb_sim_collapsible: true, collapsed: collapsed }">
      <div
        class="cblock block--child js-child"
        v-bind:class="{ hidden: finished }"
      >
        <questionStep
          :question="question.question"
          :description_short="question.description_short"
          :description_long="question.description_long"
          :question_type="question.question_type"
          :possible_answers="question.possible_answers"
          :question_tag="question.question_tag"
          :given_answer="question.answer"
          :translationAnswers="translationAnswers"
          :state="state"
          :translations="translations"
          :lang="lang"
          :region="region"
          @nextStep="nextStep"
          @previousStep="previousStep"
          v-if="question.question_tag != 'exit'"
          class="cb_sim_questionblock"
        />
      </div>
      <div>
        <div class="block js-child-container" v-if="finished">
          <div v-for="(answer, node) in data" :key="node">
            <span
              v-if="
                ![
                  'naam',
                  'jongsteCounter',
                  'childCounter',
                  'childCountTotalBXL',
                  'gezinHeeftPost2019Kind',
                  'childCounterTotal',
                ].includes(node)
              "
            >
              <span class="cb_sim_summarynode">
                {{ translateNode(node) }}
                <br />
              </span>
              <span class="cb_sim_summaryvalue">{{
                translateAnswer(answer)
              }}</span>
              <br />
            </span>
          </div>
          <div v-if="question.question_tag == 'exit'">
            <p class="cb_sim_question">{{ question.description_short }}</p>
            <p class="cb_sim_question">{{ question.description_long }}</p>
          </div>
          <div v-if="question.question_tag == 'leeftijdsgrensOverschreden'">
            <p class="cb_sim_question">{{ question.description_short }}</p>
            <p class="cb_sim_question">{{ question.description_long }}</p>
          </div>
          <!--   <span
            v-if="state != 'start'"
            class="cb_sim_link cb_sim_previous"
            style
            @click="previousStep()"
            >{{ t("previous") }}</span
          > -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
//import FormInput from "./FormInput.vue";
import { loadcockpit } from "@/components/mixins/mixins";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faChevronDown,
  faChevronRight,
  faFolderOpen,
  faSave,
  faTimes,
  faTrashAlt,
  faUpload,
  faUserSlash,
  faUserTimes,
} from "@fortawesome/free-solid-svg-icons";
import questionStep from "./questionStep.vue";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faSave);
library.add(faUpload);
library.add(faUserSlash);
library.add(faUserTimes);
library.add(faChevronDown);
library.add(faChevronRight);
library.add(faTimes);
library.add(faSave);
library.add(faFolderOpen);
library.add(faTrashAlt);

export default {
  name: "Child",
  mixins: [loadcockpit],
  components: {
    questionStep,
    FontAwesomeIcon,
  },
  props: {
    index: Number,
    jongsteCounter: String,
    childCounter: Number,
    translations: Object,
    globalQuestions: Object,
    childCountTotal: Number,
    childCountTotalBXL: Number,
    gezinHeeftPost2019Kind: Number,
    storedData: Object,
    translationAnswers: Object,
    naam: String,
    geboortedatum: String,
  },
  data: function () {
    return {
      base: "https://www.parentia.be/cb8000",
      answer: "",
      state: "start",
      previousQuestion: {},
      question: {
        question: "Naam kind",
        lang: "nl",
        question_tag: "naam",
        description_short: "Wat is de naam van het kind",
        description_long: null,
        question_type: "string",
        possible_answers: [],
        answer: null,
        globalQuestion: false,
      },
      questions: [],
      data: {
        //jongsteCounter: "1",
        geboortedatum:
          this.geboortedatum.length > 0 ? this.geboortedatum : null,
        naam: this.naam.length > 0 ? this.naam : null,
        gezinHeeftPost2019Kind: this.gezinHeeftPost2019Kind,
        childCountTotalBXL: this.childCountTotalBXL,
      },
      counter: 3,
      result: 0,
      resultamounts: {},
      finished: false,
      // naam: "",
      localData: false,
      globals: {},
      collapsed: false,
      continued_right: false,
      results: null,
    };
  },
  watch: {
    gezinHeeftPost2019Kind: function (newVal, oldVal) {
      this.data["gezinHeeftPost2019Kind"] = newVal;
      this.fetchResults();
    },
    childCountTotal: function (newVal, oldVal) {
      this.data["childCounterTotal"] = newVal;
      this.fetchResults();
    },
    childCountTotalBXL: function (newVal, oldVal) {
      this.data["childCountTotalBXL"] = newVal;
      this.fetchResults();
    },
    jongsteCounter: {
      immediate: true,
      deep: true,
      handler(newVal, oldVal) {
        this.data["jongsteCounter"] = newVal;
        this.fetchResults();
      },
    },
    childCounter: {
      immediate: true,
      deep: true,
      handler(newVal, oldVal) {
        this.data["childCounter"] = newVal;
        this.fetchResults();
      },
    },
  },
  mounted() {
    this.globals = this.globalQuestions;
    this.data["regio"] = "Vlaanderen";
    if (this.storedData.naam) {
      var d = this.storedData;
      //this.$emit("updatename", this.index, d.naam);
      this.naam = d.naam;
      //this.storedData = {};
      //this.data.jongsteCounter = "999";
      this.data = JSON.parse(JSON.stringify(d));
      this.fetchResults();
      //this.$emit("resort");
    }
  },
  methods: {
    translateAnswer: function (key) {
      try {
        if (key in this.translationAnswers[this.lang]) {
          return this.translationAnswers[this.lang][key];
        } else {
          return key;
        }
      } catch (e) {
        return key;
      }
    },
    toggleCollapsible: function () {
      if (this.collapsed) {
        this.collapsed = false;
      } else {
        this.collapsed = true;
      }
    },
    saveChild: function () {
      localStorage.setItem(
        "cbsim_child_" + this.naam,
        JSON.stringify(this.data),
      );
    },
    clearChild: function () {
      this.localData = false;
      localStorage.removeItem(this.naam);
    },
    loadChild: function () {
      this.data = JSON.parse(localStorage.getItem(this.naam));
      this.fetchResults();
    },
    deleteChild: function () {
      this.$emit("results", [], this.naam);
      this.$emit("deleteChild", this.index, this.naam);
    },
    previousStep: function () {
      this.finished = false;
      this.collapsed = false;
      this.question = this.questions.pop();
      delete this.data[this.question.question_tag];
      if (this.questions.length == 0) {
        this.state = "start";
      }
    },
    nextStep: function (res) {
      if (res.question_tag == "naam") {
        this.$emit("updatename", this.index, res["answer"]);
        if (localStorage.getItem(res["answer"])) {
          this.localData = true;
        }
      }
      if (this.question.globalQuestion) {
        this.$emit("globalQuestion", res.question_tag, res["answer"]);
      }
      this.question.answer = res["answer"];
      this.questions.push(this.question);
      this.data[res["question_tag"]] = res["answer"];

      if (this.question.question_tag == "naam") {
        this.naam = this.question.answer;
      }
      if (this.question.question_tag == "geboortedatum") {
        this.$emit("updateBirthdate", this.naam, this.question.answer);
      }
      if (this.question.question_tag == "vlaanderenSchema") {
        this.$emit("continuedRight", this.naam, this.question.answer);
      }
      this.fetchResults();
      this.state = "ongoing";
    },
    translateNode: function (node) {
      if (
        "VL0" + node in this.translations[this.lang] &&
        this.data["regio"] == "Vlaanderen"
      ) {
        return this.translations[this.lang]["VL0" + node];
      } else if (
        "VL1" + node in this.translations[this.lang] &&
        this.data["regio"] == "Vlaanderen"
      ) {
        return this.translations[this.lang]["VL1" + node];
      } else if (
        "WB0" + node in this.translations[this.lang] &&
        this.data["regio"] == "Wallonie"
      ) {
        return this.translations[this.lang]["WB0" + node];
      } else if (
        "BXL0" + node in this.translations[this.lang] &&
        this.data["regio"] == "Bruxelles"
      ) {
        return this.translations[this.lang]["BXL0" + node];
      } else if (node in this.translations[this.lang]) {
        return this.translations[this.lang][node];
      } else {
        return node;
      }
    },
    fetchResults: function () {
      this.finished = false;
      //console.log("SENDING");
      //console.log(this.data);
      axios
        .post(this.base, this.data)
        .then((response) => {
          if (true) {
            //console.log(response);
            //(!response.data.node in this.data) {
            let result = {
              question_tag: response.data.node,
              question: response.data.question,
              possible_answers: [],
              description_short: null,
              description_long: null,
              question_type: "string",
              answer: "",
              globalQuestion: false,
            };
            // New question
            if ("node" in response.data) {
              if (response.data.node.includes("datum")) {
                result["question_type"] = "date";
              }

              if ("customAttribs" in response.data) {
                if ("isGlobal" in response.data.customAttribs) {
                  if (response.data.customAttribs.isGlobal == "True") {
                    result.globalQuestion = true;
                  }
                }
              }
              if (response.data.answers) {
                let possibleAnswers = response.data.answers.split("|");
                result.question_type = "choice";
                possibleAnswers.forEach((el) => {
                  let possibleAnswer = el.replace(/'/g, "");
                  if (
                    possibleAnswer != "" &&
                    !result.possible_answers.includes(possibleAnswer)
                  ) {
                    result.possible_answers.push(possibleAnswer);
                  }
                });
                if (result.possible_answers.length == 1) {
                  result.possible_answers.push(
                    result.possible_answers[0] == "Ja" ? "Nee" : "Ja",
                  );
                  result.question_type = "choice";
                }
              }
              //result.possible_answers.sort();
              this.finished = false;
              if (response.data.node == "leeftijdsgrensOverschreden") {
                result["question"] = "<leeftijdsgrensOverschreden>";
              }
              if (
                "VL0" + result.question_tag in this.translations[this.lang] &&
                this.data["regio"] == "Vlaanderen"
              ) {
                result.question =
                  this.translations[this.lang]["VL0" + result.question_tag];
              } else if (
                "VL1" + result.question_tag in this.translations[this.lang] &&
                this.data["regio"] == "Vlaanderen"
              ) {
                result.question =
                  this.translations[this.lang]["VL1" + result.question_tag];
              } else if (
                "WB0" + result.question_tag in this.translations[this.lang] &&
                this.data["regio"] == "Wallonie"
              ) {
                result.question =
                  this.translations[this.lang]["WB0" + result.question_tag];
              } else if (
                "BXL0" + result.question_tag in this.translations[this.lang] &&
                this.data["regio"] == "Bruxelles"
              ) {
                result.question =
                  this.translations[this.lang]["BXL0" + result.question_tag];
              } else if (
                "VL0" + result.question_tag in
                this.translations[this.lang]
              ) {
                result.question =
                  this.translations[this.lang]["VL0" + result.question_tag];
              } else if (
                "VL1" + result.question_tag in
                this.translations[this.lang]
              ) {
                result.question =
                  this.translations[this.lang]["VL1" + result.question_tag];
              } else if (result.question_tag in this.translations[this.lang]) {
                result.question =
                  this.translations[this.lang][result.question_tag];
              }

              if (
                result.question_tag + "_long" in
                this.translations[this.lang]
              ) {
                result.description_short =
                  this.translations[this.lang][result.question_tag + "_long"];
              } else if (
                "VL0" + result.question_tag + "_long" in
                this.translations[this.lang]
              ) {
                result.description_short =
                  this.translations[this.lang][
                    "VL0" + result.question_tag + "_long"
                  ];
                result.description_long =
                  this.translations[this.lang][
                    "VL0" + result.question_tag + "_extra_long"
                  ];
              }
              this.question = result;
              if (this.question.question_tag in this.globals) {
                this.question.answer = this.globals[this.question.question_tag];
                this.data[this.question.question_tag] = this.question.answer;
                this.nextStep(this.question);
                return;
              }
            } else {
              this.finished = true;
              this.collapsed = true;
            }
            if (this.question.question_tag == "exit") {
              this.finished = true;
            }
            if (response.data.isExit) {
              this.finished = true;
            }
            //Resultaatverwerking
            let resultamounts = {};
            if (!this.finished) {
              var responseResult = response.data.result;
            } else {
              var responseResult = response.data;
            }
            for (var el in responseResult) {
              if (el.match(/\_EUR$/gi)) {
                var am = parseFloat(responseResult[el]).toFixed(4);
                if (am != 0.0) {
                  resultamounts[el] = am;
                }
                if (el == "GIT_EUR") {
                  this.$emit("gitcorr");
                }
              }
            }
            if (responseResult["isWezenToeslag"] == "Ja") {
              this.$emit("wezentoeslag", this.index);
            }
            // console.log(response.data);
            this.$emit("results", resultamounts, this.naam);
            //if (this.finished) {
            //this.$emit("endchild", this.data);
            //}
          }
          //console.log(response);
          //console.log(this);
        })
        .catch((error) => {
          console.log("ERROR");
          //console.log(error);
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* .cb_sim_child__container {
  transform: scale(0.8);
} */
svg {
  max-width: 1.8rem;
}

.btn_noborder {
  border: 0;
  margin: 0;
}
.cb_sim_child_header {
  display: block;
  width: 100%;
  background: #e3e8f2;
  position: relative;
}

.cb_sim_collapsible_btn {
  position: relative;
  display: inline;
  width: 100%;
  max-width: 1.8rem;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  color: #626262;
  background: #e3e8f2;
  margin-bottom: 0.3rem;
  border: none;
  padding-left: 1.5rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-right: 1.5rem;
  margin-top: 0.5rem;
  outline: none;
  cursor: pointer;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  font-weight: inherit;
  color: inherit;
  text-align: inherit;
  text-decoration: inherit;
  font-weight: 700;
  font-size: 2rem;
}
.cb_sim_collapsible {
  border: solid 1px;
  border-color: #e3e8f2;
  padding: 1.5rem;
  margin-bottom: 2rem;
  border-radius: 0.5rem;
  visibility: visible;
  opacity: 1;
  transition: all 0.2s linear;
  max-height: auto;
  position: relative;
}

.collapsed {
  transition: all 0.2s linear;
  visibility: hidden;
  opacity: 0;
  max-height: 0;
}

.btn {
  display: inline-block;
  margin: 0rem;
  padding: 0.5rem;
  border-radius: 0.5rem;
  border: 1px solid grey;
  font-size: 1.5rem;
  height: 100%;
  color: #2c7794;
}
.btn:hover {
  cursor: pointer;
}

.cb_sim_previous {
  position: absolute;
  right: 0;
  margin-right: 15rem;
  margin-top: 1rem;
}

.cb_sim_action_buttons {
  color: #2c3e50;
  position: absolute;
  right: 1rem;
}

.hidden {
  display: none;
}
.cb_sim_question {
  font-family: "Museo Sans", Helvetica, Arial, sans-serif;
  font-size: 1.6rem;
  font-weight: normal;
  line-height: 1.625;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  box-sizing: border-box;
  display: block;
  margin-bottom: 0.5rem;
  padding-left: 1rem;
  color: #423132;
  text-align: left;
}

.cb_sim_link {
  color: #2c7794;
  cursor: pointer;
}

.cb_sim_questionblock {
  position: relative;
  margin-bottom: 5rem;
}

.cb_sim_showhide {
  font-size: 0.5em;
}

.cb_sim_summaryvalue {
  font-size: 1.5rem;
  padding-left: 2rem;
}

.cb_sim_summarynode {
  font-size: 1.5rem;
  color: #423132;
  font-weight: bold;
}
</style>
